import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['prompter']

  connect() {
    super.connect()
    console.log('Hello from CloneControl')
  }

  clear(event) {
    // For facilitator interface, find and clear the textarea
    const textarea = this.element.querySelector('#speak-textarea') || this.element.querySelector('textarea')
    
    if (textarea) {
      textarea.value = ''
    } else {
      // Fallback for other interfaces - clear the event target
      if (event.target && event.target.value !== undefined) {
        event.target.value = ''
      }
    }
  }
}
